import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfirmButton = ({
  isUpdatePending,
  onSubmit
}) => {
  return /*#__PURE__*/_jsx(UILoadingButton, {
    use: "danger",
    loading: isUpdatePending,
    preventClicksOnLoading: true,
    onLoadingFinish: () => console.log('onLoadingFinish'),
    onClick: onSubmit,
    "data-confirm-button": "accept",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerCore.videoOptIn.modal.submitButton.turnOff"
    })
  });
};
const TurnOffVideoFeaturesModal = ({
  isUpdatePending,
  onSubmit,
  onClose
}) => {
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    use: "danger",
    width: 600,
    message: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.videoOptIn.modal.turnOff.header"
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerCore.videoOptIn.modal.turnOff.message"
    }),
    ConfirmButton: ConfirmButton,
    confirmButtonProps: {
      isUpdatePending,
      onSubmit
    },
    onConfirm: onSubmit,
    onReject: onClose,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerCore.videoOptIn.modal.cancel"
    }),
    "data-test-id": "turn-off-video-modal"
  });
};
export default TurnOffVideoFeaturesModal;